<template>
	<section class="actionButtons">
		<button class="button list" @click="$parent.toggleView()">
			<span v-if="state === 'Radar'">
				<font-awesome-icon icon="fa-solid fa-list" />
				{{ list }}
			</span>

			<span v-else>
				<font-awesome-icon icon="fa-solid fa-arrow-left" />
				{{  back }}
			</span>
		</button>

		<button class="button redo" @click="onReset()">
			<font-awesome-icon icon="fa-solid fa-arrow-rotate-right" />
			{{ again }}
		</button>

		<button class="button share" @click="onShare()">
			<font-awesome-icon icon="fa-solid fa-share-from-square" />
			{{  share }}
		</button>
	</section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
	props: {
		state: String
	},

	computed: {
		webShareApiSupported() {
			return navigator.share
		},
		url() {
			return window.location.href
		},
		title() {
			return document.title
		},
        ...mapState({
            list: (state) => state.dictionary.share.list,
            back: (state) => state.dictionary.share.back,
            again: (state) => state.dictionary.share.again,
            share: (state) => state.dictionary.share.share
        })
	},

	methods: {
		...mapMutations(['toggleShareModal', 'resetApp']),

		onReset() {
			this.resetApp()
			this.$router.push({ name: 'home' })
		},

		onShare() {
			if (this.webShareApiSupported) {
				this.shareAPI()
			} else {
				this.toggleShareModal()
			}
		},

		shareAPI() {
			navigator
				.share({
					title: this.title,
					url: this.url
				})
				.catch(console.error)
		}
	}
}
</script>

<style lang="scss" scoped>
.actionButtons {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	bottom: 20px;
	left: 0;
	width: 100%;
	z-index: 100;
}

.button {
	padding: 5px 15px;
	margin: 0 5px;
	border-radius: 50px;
	background: rgba(247, 153, 184, 0.5);
	color: white;
	text-transform: uppercase;
	cursor: pointer;
	border: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	backdrop-filter: blur(30px);
	text-decoration: none;
	@include type-small();
	@include type-strong();
}
</style>
